module.exports = __webpack_public_path__ + "img/grey-french-door-refrigerator-3264487.01e2d685.jpg";